import React from 'react';
import { useNavigate } from 'react-router-dom';
import { scrollToTop } from '../utils/helpers';
import logo from '../images/logo/logo.jpeg';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden shadow-md border-2 border-primary-400 mr-3">
                <img
                  src={logo}
                  alt="Ram Tirath Art Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-2xl font-bold">RamTirathArt</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Creating beautiful artwork that captures the essence of life and emotion.
              Each piece tells a unique story through color, form, and imagination.
            </p>
            <div className="flex space-x-4">
              <a href="https://in.pinterest.com/RamTirathCreations/" className="text-gray-300 hover:text-primary-400 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.347-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001.012.001z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/ramtirathart/" className="text-gray-300 hover:text-primary-400 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleNavigation('/')}
                  className="text-gray-300 hover:text-primary-400 transition-colors text-left block w-full cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/gallery')}
                  className="text-gray-300 hover:text-primary-400 transition-colors text-left block w-full cursor-pointer"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/')}
                  className="text-gray-300 hover:text-primary-400 transition-colors text-left block w-full cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Service Venues */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Service Venues</h3>
            <ul className="space-y-1.5 text-sm text-gray-300">
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Lucknow Cantt</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Central Command Officers Mess</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Madhya U.P. Sub-Area (MUPSA)</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>AMC, CMDC, Command Hospital, Base Hospital, AFMSD</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>71 Brigade, 41 Brigade, Sainik Kalyan Nidesalay, NCC Directorate, GRRC etc.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>RR Hospital, Manikshaw Centre, NCC HQ Delhi Cantt</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>RRC, SRC, KRC, Dogra Regimental Centre etc.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>91 Sub-Area Jalandhar Cantt Punjab</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>39 Mtn Div HQ Palanpur Cantt</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Div HQ, Signal HQ Bareily Cantt</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Div HQ 56 Likhabali (Assam)</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Prenna Sthal Jaipur Cantt</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>Div HQ Along (Arunanchal) etc.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                <span>APS Sunjwan Cantt J & K</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-4">
            <p className="text-gray-300 text-sm">
              © 2024 RamTirathArt. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
